import {createRouter, createWebHistory} from 'vue-router'
import store from '@/store'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/layouts/top-menu/Main.vue'),
    children: [
      {
        path: '/',
        name: 'Main',
        permission: [''],
        component: () => import('@/views/public/Main.vue'),
      },
      {
        path: '/NewsForm',
        name: 'NewsForm',
        permission: [''],
        component: () => import('@/views/public/sections/NewsForm.vue')
      },
      {
        path: '/chek-police/:id',
        name: 'CheckPolice',
        permission: [''],
        component: () => import('@/views/public/CheckPolis.vue')
      },
      {
        path: '/agent-registration/:id',
        name: 'CompleteRegistration',
        permission: [''],
        component: () => import('@/views/public/CompleteRegistration.vue')
      },
      {
        path: '/resetPassword',
        name: 'ResetPassword',
        permission: [''],
        component: () => import('@/views/public/ResetPasswordConfirm.vue')
      },
    ]
  },
  {
    path: '/404',
    name: 'ErrorPage',
    component: () => import('@/views/error-page/Main.vue')
  },
  {
    path: '/403',
    name: 'ErrorPage403',
    component: () => import('@/views/error-page/Main403.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@/views/error-page/Main.vue')
  },
  {
    path: '/osago/calculation/checkVypiska/:id',
    name: 'CheckVypiskaPdf',
    component: () => import('@/views/public/sections/components/CheckVypiska.vue')
  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
        top: -400,
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { left: 0, top: 0 };
    }
  },
})

export default router
